import * as React from 'react';

import ActiveBasketContainsItemWithId from './ActiveBasketContainsItemWithId';
import ActiveBasketContainsItemWithName from './ActiveBasketContainsItemWithName';
import ActiveBasketValueIsAtLeast from './ActiveBasketValueIsAtLeast';
import ActiveBasketValueIsLessThan from './ActiveBasketValueIsLessThan';
import BrowseAbandonment from './BrowseAbandonment';
import CartAbandonment from './CartAbandonment';
import DeviceType from './DeviceType';
import ExcludeEmailSource from './ExcludeEmailSource';
import IncludeEmailSource from './IncludeEmailSource';
import Geolocation from './Geolocation';
import ImpressionPathWhitelist from './ImpressionPathWhitelist';
import NoActiveMarketingPermission from './NoActiveMarketingPermission';
import { OwnProps as ImportedOwnProps } from './props';
import UserLoggedIn from './UserLoggedIn';

export type OwnProps = ImportedOwnProps;

export const Forms: { [name: string]: React.ComponentClass<OwnProps> } = {
  ActiveBasketContainsItemWithId,
  ActiveBasketContainsItemWithName,
  ActiveBasketValueIsAtLeast,
  ActiveBasketValueIsLessThan,
  CartAbandonment,
  BrowseAbandonment,
  DeviceType,
  ExcludeEmailSource,
  IncludeEmailSource,
  ImpressionPathWhitelist,
  NoActiveMarketingPermission,
  Geolocation,
  UserLoggedIn,
} as any;

export default Forms;
